<!-- <div class="Login"> -->
<ion-content>
  <div class="Login__ContentWrapper">
    <ion-card class="Login__Card">
      <ion-card-header>
        <ion-card-title>Log in to continue.</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <p>
          To protect your data and ensure your changes are securely saved,
          please log in or create an account. This helps keep your information
          private and available whenever you return.
        </p>
        <p>
          We will never have access to your password or any other confidential
          information.
        </p>
      </ion-card-content>
    </ion-card>

    <ion-card class="Login__Card">
      <ion-card-content>
        <smartflip-login-email-form
          [loginForm]="loginForm"
          [resettingPassword]="resettingPassword"
          [showPasswordResetConfirmation]="showPasswordResetConfirmation"
          [error]="error"
          (loginButtonClicked)="emailLogin()"
          [(forgotPassword)]="forgotPassword"
          [(newAccount)]="newAccount"
          (newAccountChange)="handleNewAccountChange()"
          (forgotPasswordChange)="handleForgotPasswordChange()"
        ></smartflip-login-email-form>

        @if (!newAccount && !forgotPassword) {
          <div class="Login__SocialButtons">
            <h6 class="Login__Message">
              Or sign in with your provider of choice
            </h6>

            @for (loginButton of federatedLoginButtons; track loginButton) {
              <ion-button
                color="primary"
                class="Login__Button m-2"
                (click)="federatedLogin(loginButton.provider)"
              >
                <i class="fab" [ngClass]="loginButton.icon"></i>
                <ion-icon [name]="loginButton.icon"></ion-icon>
                <span [innerHTML]="loginButton.buttonText"></span>
              </ion-button>
            }
          </div>
        }
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
<ion-footer class="Login__Footer">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button> <div class="Login__Logo"></div> </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="openLink(privacyPolicyUrl)">
        Privacy Policy
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar color="primary">
    <ion-title class="Login__Copyright text-center">
      Copyright &#64;{{ currentYear }} The Smart Flip, LLC.
    </ion-title>
  </ion-toolbar>
</ion-footer>

<!-- </div> -->
